var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M.75 0a.75.75 0 1 0 0 1.5h2.06l.94 12.22A2.5 2.5 0 0 0 5.5 18a2.5 2.5 0 0 0 2.3-3.5h4.4a2.5 2.5 0 0 0 2.3 3.5 2.5 2.5 0 0 0 0-5H5.2l-.1-1.3 10.97-.95a.75.75 0 0 0 .67-.62l1.25-7a.75.75 0 0 0-.74-.88H4.37L4.25.69A.75.75 0 0 0 3.5 0H.75ZM5.5 14.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm8 1a1 1 0 1 1 2 0 1 1 0 0 1-2 0ZM4.48 3.75l.5 6.46 10.38-.9 1-5.56H4.47Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/Cart.40dcf3ffd5e290199ead3ee6be9fc697.svg";
export { ForwardRef as ReactComponent };